export const sharedDocumentsMapping = [
	{
		label: 'Proof of Identity',
		value: 'proofOfIdentity'
	},
	{
		label: 'Academic Transcript',
		value: 'academicTranscript'
	},
	{
		label: 'Standardized Test Score Report',
		value: 'standardizedTestScoreReport'
	},
	{
		label: 'AP Test Score Report',
		value: 'apiTestScoreReport'
	},
	{
		label: 'English Proficiency Test',
		value: 'engProficiencyTest'
	},
	{
		label: 'Counselor Recommendation',
		value: 'counselorRecommendation'
	},
	{
		label: 'Teacher Recommendation',
		value: 'teacherRecommendation'
	},
	{
		label: 'Personal Statements',
		value: 'personalStatements'
	},
	{
		label: 'Application Essay',
		value: 'applicationEssay'
	},
	{
		label: 'Resume/CV',
		value: 'cv'
	}
];
